import React, { useEffect} from 'react'
import {Link} from 'react-router-dom'
import { useSelector } from 'react-redux';
import Button from './../components/forms/Button'
import DashAuthWrapper from './../components/DashAuthWrapper'

const mapState = ({ user }) => ({
	currentUser: user.currentUser
})

const Invoices = props => {
	const { currentUser } = useSelector(mapState);

	useEffect(() => {
		window.scrollTo(0, 0)
	  }, [])
	

	const congfigAuthWrapper = {
		headline: 'Invoices'
	}

	return (
		<div>
			{!currentUser.subscribed &&(
				<DashAuthWrapper>
					<h3 className="mt-5">You currently have no subscription</h3>
				
					<h3>Please 
						<Link to="/services">
							<Button>
								SUBSCRIBE
							</Button>
						</Link>
						to be eligible for services
					</h3>
				</DashAuthWrapper>
			)}

			{currentUser.subscribed &&(
				<DashAuthWrapper {...congfigAuthWrapper}>
				
				
				</DashAuthWrapper>
			)}
		</div>	




		
	)
}

export default Invoices;